"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnDHint = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function DnDHint({ className }) {
    return ((0, jsx_runtime_1.jsxs)(Hint, { className: className, "data-e2e": 'DnDHint_Hint', children: [(0, jsx_runtime_1.jsx)(DragNDropIcon, { name: ui_1.Icons.Drag_N_Drop, "data-e2e": 'DnDHint_DragNDropIcon' }), (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.rearrangeHint)] }));
}
exports.DnDHint = DnDHint;
const Hint = styled_components_1.default.div `
  display: flex;
  flex-flow: row;
  align-items: center;

  max-width: 410px;
  margin-bottom: 16px;
  padding: 0;

  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: 14px;
`;
const DragNDropIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 50px;
  height: 32px;

  margin-right: 12px;

  color: ${({ theme }) => theme.designSystem.background};

  ${ui_1.device.tablet((0, styled_components_1.css) `
    width: 28px;
  `)}
`;
